import { c as create_ssr_component, v as validate_component } from "../../../../chunks/ssr.js";
import { B as BookOpenPageVariant, S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { A as AccountCowboyHatOutline } from "../../../../chunks/AccountCowboyHatOutline.js";
import { A as AirplaneTakeoff } from "../../../../chunks/AirplaneTakeoff.js";
import { C as CheckDecagram } from "../../../../chunks/CheckDecagram.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
let programs = true;
let pricingPackage = false;
let professionalProgram = false;
let background_center = false;
let hero_image = "/ramp.webp";
let h1 = "Private Pilot Program";
let hero_paragraph_content = "Earning your Private Pilot's License allows you to operate a single-engine aircraft following visual flight rules (VFR), which require a minimum visibility of three miles and also permits nighttime flying. Carrying passengers is permitted, however you are not allowed to receive compensation for your services. You are permitted to share the operational costs with your passengers.";
let center_img_seperating_section = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let roadmap_stages = [
    [
      {
        text: "Orientation / Discover flight",
        icon: AccountCowboyHatOutline
      },
      {
        text: "Private Pilot Training",
        icon: BookOpenPageVariant
      },
      {
        text: "Private Pilot Checkride",
        icon: AirplaneTakeoff
      },
      {
        text: "Private Pilot Acheived",
        icon: CheckDecagram
      }
    ]
  ];
  let second_center_img_seperating_section = {
    src: "/student_with_certificate.webp",
    alt: "Student pilot with temporary airman certificate"
  };
  let prerequisites = {
    eligibility: [
      "Be at least 17 years old",
      "Be able to read, speak, write, and understand the English language proficiently",
      "Hold a U.S. student pilot, sport pilot, or recreational pilot certificate",
      "Receive ground training or home study the required aeronautical knowledge",
      "Have an instructor certifying that you are prepared for the required knowledge test",
      "Have an instructor certify that you are prepared for the practical test",
      "Pass the knowledge test on aeronautical knowledge",
      "Have received flight training from a certified flight instructor in areas of operation (listed below)",
      "Pass the practical test"
    ],
    proficiency: [
      "Preflight preparation",
      "Preflight procedures",
      "Airport operations",
      "Takeoffs, landings, and go-arounds",
      "Performance maneuvers",
      "Ground reference maneuvers",
      "Navigation",
      "Slow flight and stalls",
      "Basic instrument maneuvers",
      "Emergency operations",
      "Night operations",
      "Post-flight procedures"
    ],
    experience: [
      "At least 40 total hours of flying",
      "At least 20 hours of flight training",
      "At least 10 hours of solo flight",
      "At least 5 hours of solo cross-country flying",
      "One solo cross country flight of 150 nautical miles total distance, with full-stop landings at three points, and one segment of the flight consisting of a straight-line distance of more than 50 nautical miles between the takeoff and landing locations",
      "3 takeoffs and landings involving flight in the airport traffic pattern with an operational control tower",
      "At least 3 hours of cross-country training",
      "At least 3 hours of night flight training",
      "One cross-country over 100nm",
      "10 takeoffs and landings involving flight in the airport traffic pattern",
      "At least 3 hours of simulated instrument training"
    ]
  };
  let faqs = [
    {
      question: "What is a Private Pilot License (PPL)?",
      answer: "A Private Pilot License (PPL) is a certificate that allows individuals to operate aircraft for personal use and non-commercial purposes. It's the first step towards becoming a pilot.",
      opened: false
    },
    {
      question: "Do I need any prior experience to start a private pilot course?",
      answer: "No prior experience is required. Private pilot courses are designed for beginners. However, you must be at least 17 years old to apply for a PPL.",
      opened: false
    },
    {
      question: "How long does it take to get a private pilot license?",
      answer: "The duration of the course can vary depending on factors like your availability and the flight school's curriculum. On average, it takes about 3 to 6 months to earn a PPL.",
      opened: false
    },
    {
      question: "Can I work while taking the course?",
      answer: "Many students work part-time while pursuing their PPL. However, it's essential to balance your time effectively to ensure successful completion of the course.",
      opened: false
    },
    {
      question: "What subjects will I study during the private pilot course?",
      answer: "You will study a range of topics, including aerodynamics, navigation, meteorology, aircraft systems, regulations, and flight planning.",
      opened: false
    },
    {
      question: "Can I choose when to schedule my flight lessons?",
      answer: "Yes, flight lessons are often flexible and can be scheduled to fit your availability, as long as your flight instructor is available.",
      opened: false
    }
  ];
  return `${$$result.head += `<!-- HEAD_svelte-1qo117z_START -->${$$result.title = `<title>Private Pilot | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation private pilot training"><!-- HEAD_svelte-1qo117z_END -->`, ""} ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
    $$result,
    {
      programs,
      faqs,
      pricingPackage,
      professionalProgram,
      hero_image,
      background_center,
      h1,
      hero_paragraph_content,
      roadmap_stages,
      center_img_seperating_section,
      second_center_img_seperating_section,
      prerequisites
    },
    {},
    {
      three: () => {
        return `<div slot="three">${validate_component(CopyCard, "CopyCard").$$render($$result, { src: "/wings.webp" }, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-1nlm994">A check-ride is an essential part of the pilot certification process
        that includes both a flight test and an oral exam. During a check-ride,
        a designated pilot examiner (DPE) assesses the pilot&#39;s ability to
        operate an aircraft safely and proficiently. The examination covers
        various aspects, including flight maneuvers, navigation, emergency
        procedures, communication skills, and a thorough understanding of
        aviation regulations.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-5aur3t">Checkride Information</div>`;
          }
        })}</div>`;
      },
      two: () => {
        return `<div slot="two">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-beirt3">In order to begin your training you must be able to read, write, speak
        and understand English proficiently. Before you can fly, you&#39;ll need to
        pass your medical exam and acquire a medical certificate from an FAA
        approved aviation medical examiner (AME). You will also need to show
        proof of U.S. Citizenship or TSA approval as well as your student pilot
        certificate.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-gjaehl">What Do You Need to Start?</div>`;
          }
        })}</div>`;
      },
      one: () => {
        return `<div slot="one">${validate_component(CopyCard, "CopyCard").$$render($$result, { src: "/sump.webp" }, {}, {
          text: () => {
            return `<div slot="text" data-svelte-h="svelte-gtez2e">Our Private Pilot Training course includes ground and flight instruction
        in which you are able to complete at your own pace, so you can be on
        your way to flying your own airplane in practically no time. You will be
        training with some of our finest instructors, using high quality Piper
        and Cessna aircraft, some of which include full glass flight decks. No
        prior flight experience required.</div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-1kkxrt0">Course Description</div>`;
          }
        })}</div>`;
      }
    }
  )}`;
});
export {
  Page as default
};
